import styles from "./tabQueueTransfer.module.scss";
import { AntInput } from "../../antinput";
import { Fragment, useEffect, useState } from "react";
import callChatService from "../../../../base/service/chatService";
import store from "../../../../store/redux-store/root_store";
import { useSelector } from "react-redux";
import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { CallService } from "../../../../services/call_service";
import { dispositionSliceActions } from "../../../../store/slices/dispositionSlice/postDisposition";

function TabTransferCallFLow() {
  const dispatch = useDispatcher();
  const navigate = useNavigate()
  const callFlow: any = useSelector((state: any) => state.callPopUpDetails.callList);
  const { dialPadChanges } = CallService(dispatch, navigate)
  const [callFlowList, setCallFlowList] = useState(callFlow || []);
  const { dispositionTagList } = useSelector((state: any) => state.contactListForAgent);

  const makeCall = async (id: any) => {
    const roomData: any = store.getState().chatReducer;
    dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "CALLFLOW" }));
    let transferdata: any = {
      session_id: roomData?.currentSession?.sessionId,
      req_type: "AGENT_TRANSFER",
      transfer_type: 4,
      callFlowId: `${id}`
    };
    callChatService.transfer(transferdata);
    dialPadChanges(false, false, false, false, false, false);
    const dis = dispositionTagList?.find((i: { dispositionName: any; }) => i.dispositionName === 'Transferred')
    dispatch(dispositionSliceActions.setDisposition({ key: dis }));
  };


  const getCallFlowList = (e:any) => {
    const searchTerm = e?.target?.value?.trim().toLowerCase();

    if (searchTerm) {
      const filteredFlow = callFlow.filter((flow : any) =>
        flow.templateName.toLowerCase().includes(searchTerm)
      );
      setCallFlowList(filteredFlow);
    } else {
      setCallFlowList(callFlow);
    }
  }; 

  useEffect(() => {
    setCallFlowList(callFlow);
  }, [callFlow]);
  
  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <AntInput className="transferSearch searchbordered" onChange={getCallFlowList} placeHolder="Search" />
        <div className={styles.agentsList}>
          {callFlowList?.length === 0
            ? "No data"
            : callFlowList.map((data: any, idx: any) => {
              return (
                <Fragment key={idx}>
                  <div className={`${styles.users}`} onClick={() => makeCall(data.cfid)}>
                    <div className={styles.callStatus}>
                      <div className={styles.ready}></div>
                    </div>
                    <div className={styles.userDetails}>
                      <span className={styles.agentName}>{data?.templateName}</span>
                    </div>
                  </div>
                </Fragment>
              );
            })}
        </div>
      </div>
    </>
  );
}
export default TabTransferCallFLow;
